module.exports = __webpack_public_path__ + "static/media/microservices.0d0710d8.jpeg";